module.exports = __webpack_public_path__ + "img/Home.68fcb81e.png";